import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./outline.module.css"

interface Sig {
  Args: {
    instructionalCourses: Array<Course>
    selectedCourse: Course
    planbook: Planbook
  }
}

export default class PerspectiveOutline extends Component<Sig> {
  readonly styles = styles

  // args
  focusedItemId
  canBeEditable
  isSelectable
  onNewFocusedItemId

  @service declare modalManager: ModalManager

  printOrDownload = () => {
    this.modalManager.openModal("planner/modals/print-download", {
      courseId: this.args.selectedCourse.id,
      planbookId: this.args.planbook.id,
      layout: "course-outline",
      canPrint: true,
    })
  }
}
